

import React, { useEffect, useState } from 'react';
import { Card, Divider, Button, Backdrop, CircularProgress } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import services from '../../services';
import { toast } from 'react-toastify';
import { QRCodeCanvas } from 'qrcode.react';
import { socket } from '../../socket';
import { styles } from './WhatsAuthUser.styles';
import AppModal from '../../common/AppModal';
import { FiSmartphone, FiAlertCircle } from 'react-icons/fi';

const AddClient = ({ addClientStatus, setAddClientStatus, getClientWhatsapp, setAllClient }) => {
    const [clientName, setClientName] = useState('');
    const [error, setError] = useState('');

    const validateClientName = (name) => {
        if (!name) return 'Please enter a name';
        const regex = /^[a-zA-Z0-9]*$/;
        if (!regex.test(name)) return 'Name cannot contain spaces or special characters';
        return '';
    };

    const handleClientAdd = async () => {
        try {
            const response = await services.Whatsapp.CLIENT_GENERATE({ clientId: clientName });
            const res = await services.Whatsapp.GET_ALL_CLIENT();
            getClientWhatsapp();
            toast.success('Client Add SuccessFully...');

        } catch (error) {
            toast.error(error?.response?.data?.error || 'Error adding client'); P
        }
    };
    const handleSubmit = () => {
        const validationError = validateClientName(clientName);
        if (validationError) {
            setError(validationError);
            return;
        }
        handleClientAdd();
        setAddClientStatus(false);
        setClientName('');
        setError('');
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setClientName(value);
        setError(validateClientName(value));
    };
    return (
        <AppModal
            show={addClientStatus}
            onClose={() => { setAddClientStatus(false); setClientName(''); setError(''); }}
            icon={
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.132.558 4.133 1.528 5.874L.057 23.215a.75.75 0 00.916.927l5.521-1.438A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.907 0-3.693-.504-5.234-1.383l-.374-.217-3.878 1.009 1.037-3.775-.237-.389A9.956 9.956 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
                </svg>
            }
            title="Add WhatsApp Client"
            subtitle="Enter a unique name to identify this account"
            maxWidth="460px"
            footer={
                <>
                    <button
                        onClick={() => { setAddClientStatus(false); setClientName(''); setError(''); }}
                        style={{ padding: '8px 20px', borderRadius: '8px', border: '1px solid #d1d5db', background: '#fff', color: '#374151', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}
                        onMouseEnter={e => { e.currentTarget.style.background = '#f3f4f6'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = '#fff'; }}
                    >
                        Close
                    </button>
                    <button
                        onClick={handleSubmit}
                        style={{ padding: '8px 24px', borderRadius: '8px', border: 'none', background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)', color: '#fff', fontSize: '14px', fontWeight: '600', cursor: 'pointer', boxShadow: '0 2px 8px rgba(26,125,62,0.25)' }}
                        onMouseEnter={e => { e.currentTarget.style.background = '#145f30'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)'; }}
                    >
                        Save
                    </button>
                </>
            }
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151' }}>Client Name</label>
                <input
                    type="text"
                    placeholder="e.g. my-business-account"
                    value={clientName}
                    onChange={handleInputChange}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                    style={{ width: '100%', padding: '10px 14px', borderRadius: '8px', border: error ? '1.5px solid #ef4444' : '1.5px solid #d1d5db', fontSize: '14px', color: '#111827', outline: 'none', background: '#fff', boxSizing: 'border-box', transition: 'border-color 0.15s' }}
                    onFocus={e => { if (!error) e.currentTarget.style.borderColor = '#1a7d3e'; }}
                    onBlur={e => { if (!error) e.currentTarget.style.borderColor = '#d1d5db'; }}
                />
                {error && (
                    <p style={{ fontSize: '12px', color: '#ef4444', margin: 0, display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                        {error}
                    </p>
                )}
                <p style={{ fontSize: '12px', color: '#9ca3af', margin: 0 }}>Only letters and numbers allowed, no spaces or special characters.</p>
            </div>
        </AppModal>
    );
};
const QrBlock = ({ onClose, qrStatus, clientQr, setStep }) => {
    const [qrCodeData, setQrCodeData] = useState(null);
    useEffect(() => {
        if (clientQr) {
            handleGenerateQr();
        }
    }, [clientQr]);
    const handleGenerateQr = async () => {
        try {
            const response = await services.Whatsapp.CLIENT_GENERATE_QRCODE(clientQr);
            const qrData = response?.data?.data?.[0];
            setQrCodeData(qrData?.qr);
            qrData?.whatsappConnected == 'Connected' && onClose();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <AppModal
            show={qrStatus}
            onClose={() => { onClose(); setStep(1); }}
            icon={<FiSmartphone size={18} color="#fff" />}
            title="Scan QR Code"
            subtitle="Connect your WhatsApp account"
            maxWidth="400px"
        >
            <div className="qr-modal-body">

                {/* Step guide */}
                <div className="qr-modal-steps">
                    <div className="qr-modal-step">
                        <div className="qr-modal-step-num">1</div>
                        <div className="qr-modal-step-text">Open WhatsApp on your phone</div>
                    </div>
                    <div className="qr-modal-step-divider" />
                    <div className="qr-modal-step">
                        <div className="qr-modal-step-num">2</div>
                        <div className="qr-modal-step-text">Go to Settings → Linked Devices</div>
                    </div>
                    <div className="qr-modal-step-divider" />
                    <div className="qr-modal-step">
                        <div className="qr-modal-step-num">3</div>
                        <div className="qr-modal-step-text">Tap "Link a Device" &amp; scan below</div>
                    </div>
                </div>

                {/* QR code or loading */}
                {qrCodeData ? (
                    <div className="qr-modal-canvas-wrap">
                        <QRCodeCanvas value={qrCodeData} size={220} />
                    </div>
                ) : (
                    <div className="qr-modal-loading">
                        <div className="qr-modal-spinner" />
                        Generating QR code…
                    </div>
                )}

                {/* Hint */}
                <div className="qr-modal-hint">
                    <FiAlertCircle size={14} />
                    QR code expires in a few minutes. Refresh if it stops working.
                </div>

            </div>
        </AppModal>
    );
};
const WhatsappAuth = ({ whatsAppStatus, onClose }) => {
    const [allClient, setAllClient] = useState([]);
    const [addClientStatus, setAddClientStatus] = useState(false);
    const [qrStatus, setQrStatus] = useState(false);
    const [clientQr, setClientQr] = useState('');
    const [step, setStep] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getClientWhatsapp();
    }, []);
    const getClientWhatsapp = async () => {
        setIsLoading(true);
        try {
            const { data } = await services.Whatsapp.GET_ALL_CLIENT();
            setAllClient(data || []);
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeleteClient = async (id) => {
        setIsLoading(true);
        try {
            const response = await services.Whatsapp.DELETE_WHATSAPP_CLIENT(id, {
                whatsappConnected: "Disconnected"
            });
            await getClientWhatsapp();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {!addClientStatus && step === 1 && (
                <Modal show={whatsAppStatus} onHide={onClose} centered size="xl">
                    <Modal.Header closeButton style={styles.modalHeader}>
                        <Modal.Title>
                            <div style={styles.modalTitleRow}>
                                <div style={styles.titleIcon}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="#1a7d3e">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                                        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.132.558 4.133 1.528 5.874L.057 23.215a.75.75 0 00.916.927l5.521-1.438A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.907 0-3.693-.504-5.234-1.383l-.374-.217-3.878 1.009 1.037-3.775-.237-.389A9.956 9.956 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
                                    </svg>
                                </div>
                                <span style={styles.titleText}>Synced WhatsApp Accounts</span>
                                <span style={styles.countBadge}>{allClient.length}</span>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Divider />
                    <Modal.Body style={styles.modalBody}>
                        {allClient && allClient.length > 0 ? (
                            <div style={styles.tableWrapper}>
                                <table style={styles.table}>
                                    <thead>
                                        <tr style={styles.theadRow}>
                                            <th style={{ ...styles.th, width: '48px' }}>No.</th>
                                            <th style={styles.th}>Name</th>
                                            <th style={styles.th}>Created</th>
                                            <th style={styles.th}>Last Updated</th>
                                            <th style={styles.th}>Status</th>
                                            <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allClient.map((item, index) => (
                                            <tr
                                                key={item.id || item.clientId}
                                                style={styles.row}
                                                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f6fdf8'; }}
                                                onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
                                            >
                                                <td style={{ ...styles.td, color: '#9ca3af', fontWeight: '600' }}>{index + 1}</td>
                                                <td style={styles.td}>
                                                    <div style={styles.nameCell}>
                                                        <div style={styles.avatar}>{(item?.clientId || '?').charAt(0).toUpperCase()}</div>
                                                        <span style={{ fontWeight: '500', color: '#111827' }}>{item?.clientId || '-'}</span>
                                                    </div>
                                                </td>
                                                <td style={{ ...styles.td, color: '#6b7280' }}>{item?.createdAt ? new Date(item.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                                                <td style={{ ...styles.td, color: '#6b7280' }}>{item?.updatedAt ? new Date(item.updatedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                                                <td style={styles.td}>
                                                    <span style={item?.whatsappConnected === 'Connected' ? styles.connectedBadge : styles.notConnectedBadge}>
                                                        {item?.whatsappConnected === 'Connected' ? 'Connected' : 'Not Connected'}
                                                    </span>
                                                </td>
                                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                                    {item?.whatsappConnected !== 'Connected' ? (
                                                        <button
                                                            style={styles.scanQrBtn}
                                                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f0fdf4'; }}
                                                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                                                            onClick={() => {
                                                                setQrStatus(true);
                                                                setClientQr(item?.clientId);
                                                                setStep(2);
                                                            }}
                                                        >
                                                            Scan QR
                                                        </button>
                                                    ) : (
                                                        <button
                                                            style={styles.disconnectBtn}
                                                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#b91c1c'; }}
                                                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#dc2626'; }}
                                                            onClick={() => handleDeleteClient(item?.id)}
                                                        >
                                                            Disconnect
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div style={styles.emptyState}>
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z" />
                                </svg>
                                <p style={{ marginTop: '12px', color: '#9ca3af', fontSize: '14px' }}>No synced WhatsApp accounts found</p>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={styles.modalFooter}>
                        <button
                            style={styles.btnPrimary}
                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                            onClick={() => setAddClientStatus(true)}
                        >
                            + Sync New WhatsApp
                        </button>
                    </Modal.Footer>
                </Modal>
            )}
            {addClientStatus && (
                <AddClient
                    addClientStatus={addClientStatus}
                    setAddClientStatus={setAddClientStatus}
                    getClientWhatsapp={getClientWhatsapp}
                    setAllClient={setAllClient}
                />
            )}

            {qrStatus && step === 2 && (
                <QrBlock
                    qrStatus={qrStatus}
                    clientQr={clientQr}
                    setStep={setStep}
                    step={step}
                    onClose={() => {
                        setQrStatus(false);
                        setClientQr('');
                        getClientWhatsapp();
                    }}
                />
            )}
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.modal + 1 })}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default WhatsappAuth;
